import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import { useAppAuth } from '../auth/appAuth';
import { useLocation } from 'react-router-dom';

const LoginPage: React.FC = () => {
  const { loginWithRedirect } = useAppAuth();
  const location = useLocation();
  const rawReturnTo = (location.state as { returnTo?: string } | null)?.returnTo;
  const returnTo = typeof rawReturnTo === 'string' && rawReturnTo.startsWith('/') ? rawReturnTo : undefined;
  
  const handleLogin = async () => {
    await loginWithRedirect({
      appState: returnTo ? { returnTo } : undefined,
      authorizationParams: {
        redirect_uri: `${window.location.origin}/callback`,
      }
    });
  };
  
  return (
    <Box 
      sx={{ 
        height: '100vh', 
        display: 'flex', 
        flexDirection: 'column', 
        alignItems: 'center', 
        justifyContent: 'center',
        background: 'linear-gradient(135deg, #111111 0%, #1a1a1a 100%)',
        color: '#000000',
        margin: 0,
        padding: 0,
        minHeight: '100vh',
        width: '100vw',
        position: 'fixed',
        top: 0,
        left: 0
      }}
    >
      <Box
        sx={{
          maxWidth: '400px',
          width: '90%',
          padding: '40px',
          borderRadius: '12px',
          background: 'linear-gradient(135deg, rgba(0, 0, 0, 0.95) 0%, rgba(17, 17, 17, 0.95) 100%)',
          boxShadow: '0px 4px 30px rgba(176, 38, 255, 0.2)',
          border: '1px solid rgba(176, 38, 255, 0.1)',
          backdropFilter: 'blur(10px)',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: '24px'
        }}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: '2px',
            marginBottom: '8px'
          }}
        >
          <Typography variant="h3" sx={{ 
            fontWeight: 700,
            letterSpacing: '0.02em',
            textAlign: 'center',
            background: 'linear-gradient(135deg, #B026FF 0%, #9B00E6 100%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
          }}>
            INK
          </Typography>
          <Typography variant="h3" sx={{ 
            fontWeight: 700,
            letterSpacing: '0.02em',
            textAlign: 'center',
            color: '#ffffff',
          }}>
            LANTERN
          </Typography>
        </Box>

        <Typography variant="h4" sx={{ 
          fontWeight: 600,
          textAlign: 'center',
          color: '#B026FF',
          opacity: 0.9
        }}>
          Welcome Back
        </Typography>

        <Typography variant="body1" sx={{ 
          textAlign: 'center',
          color: 'rgba(255, 255, 255, 0.7)',
          mb: 2
        }}>
          Sign in to access your Brand Tracker dashboard
        </Typography>

        <Button
          onClick={handleLogin}
          variant="contained"
          sx={{
            backgroundColor: '#B026FF',
            color: '#ffffff',
            padding: '12px 32px',
            fontSize: '1rem',
            fontWeight: 600,
            textTransform: 'none',
            borderRadius: '8px',
            '&:hover': {
              backgroundColor: '#C24FFF',
              boxShadow: '0px 4px 20px rgba(176, 38, 255, 0.3)',
            },
            width: '100%',
            transition: 'all 0.2s ease-in-out'
          }}
        >
          Sign In
        </Button>
      </Box>
    </Box>
  );
};

export default LoginPage; 